import { colors } from '../../../../stylesheet'

export const tutorLicensingFeeStyles = {
  header: {
    backgroundColor: colors.lightBlue,
    color: colors.royalBlue.main,
    border: `1px solid white`,
    fontWeight: 'bold',
    padding: 8,
  },
  subHeader: {
    paddingLeft: 4,
    fontSize: 14,
  },
  subHeaderRow: {
    fontSize: 14,
  },
  paymentHeaderCell: {
    padding: 8,
    border: `1px solid white`,
    backgroundColor: colors.lightBlue,
    '@media print and (orientation:landscape)': {
      backgroundColor: `${colors.lightBlue}!important`,
    },
    '@media print and (orientation:portrait)': {
      backgroundColor: `${colors.lightBlue}!important`,
    },
  },
  bodyCell: {
    fontSize: '12.25px !important',
  },
}
